// extracted by mini-css-extract-plugin
export var partners = "partners-module--partners--7b876";
export var row = "partners-module--row--841de";